import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_MINI_WIDTH = 90;

const SidebarContext = createContext(null);

export const useSidebar = () => {
  const value = useContext(SidebarContext);
  if (!value) throw new Error("useSidebar was used outside its provider.");
  return value;
};

export const SidebarProvider = ({ children }) => {
  const [mini, setMini] = useState(true);

  // Stable identities so effects that collapse-on-mount don't re-fire when the user reopens the sidebar.
  const toggleMini = useCallback(() => setMini((previous) => !previous), []);
  const expand = useCallback(() => setMini(false), []);
  const collapse = useCallback(() => setMini(true), []);

  const value = useMemo(
    () => ({
      mini,
      width: mini ? SIDEBAR_MINI_WIDTH : SIDEBAR_WIDTH,
      toggleMini,
      expand,
      collapse,
    }),
    [mini, toggleMini, expand, collapse],
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
